import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MenuService } from './menu.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MenuItemLocal } from './menu-item.model';
import { ApiList } from '../../API/api-list.enum';
import _ from 'lodash';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../shared/services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FavoritesApiService } from '../../../../projects/api/src/favorite/favorites-api.service';
import { FavoriteModel, FavoriteType } from '../../../../projects/api/src/favorite/favorite.model';
import { InsparkMessageService } from '@inspark/inspark-components';
import {
  ConnectionPositionPair,
  CdkConnectedOverlay,
  CdkOverlayOrigin,
} from '@angular/cdk/overlay';
import { ApplicationsApiService } from '../../../../projects/api/src/applications/applications-api.service';
import { ApplicationModel } from '../../../../projects/api/src/applications/application.model';
import { ConfigureService } from '../../../../projects/common/modules/configure/configure.service';
import { MainTempService } from '../main-temp.service';
import { LocalStorageService } from '../../../../projects/api/src/locale-storage/locale-storage.service';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { A11yModule } from '@angular/cdk/a11y';
import { MenuContainerComponent } from './menu-container/menu-container.component';
import { ICONS_MAP } from '../../shared/constnts/icons-map';

const DESKTOP_WIDTH = 1200;

const gettext = (a) => a;

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  standalone: true,
  imports: [
    CdkOverlayOrigin,
    NgForOf,
    NgIf,
    NgClass,
    SharedModule,
    CdkConnectedOverlay,
    A11yModule,
    MenuContainerComponent,
  ],
  // styleUrls: ['./menu.component.scss']
  // styles: [`.c-sidebar__container {scrollbar-width: none;} .c-sidebar__container::-webkit-scrollbar {display: none;}`]
})
export class MenuComponent implements OnInit, OnDestroy, AfterViewInit {
  @Output() onSidebarStateChange = new EventEmitter<boolean>();
  public menuArray: MenuItemLocal[];
  public appMenuArray: MenuItemLocal[];
  public applications: ApplicationModel[];
  favoriteMenuArray: MenuItemLocal[];
  public menuType: FavoriteType;
  @HostBinding('class') classes = 'c-sidebar t-sidebar';
  // @ts-ignore
  @ViewChild(CdkConnectedOverlay) cdkConnectedOverlay: CdkConnectedOverlay;

  public hotKey = [];
  @HostListener('window:resize', ['$event'])
  onResize = _.throttle((event) => {
    this.checkSize();
  }, 100);

  public isMenuCollapsed = this.menuService.isCollapsed;
  public isMenuClosed = this.menuService.isCollapsed;
  public isDesktop = false;
  menufilter: any = '';
  public init = false;
  selIndex = 0;
  /*@HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      const value = this.menuService.isCollapsed.getValue();
      if (this.menuService.isCollapsed.getValue()) {
        this.init = !this.init;
        this.menuService.isCollapsed.next(true);
      } else if (this.init) {
        this.init = !this.init;
        this.menuService.isCollapsed.next(!this.menuService.isCollapsed.getValue());
      } else {
        this.init = !this.init;
      }
    } else if (!this.menuService.isCollapsed.getValue()) {
      if (event.target.parentElement.className === 'c-main-menu__item-symbol') {
        this.menuService.isCollapsed.next(!this.menuService.isCollapsed.getValue());
      }
      //this.init = !this.init;
      //this.menuService.isCollapsed.next(!this.menuService.isCollapsed.getValue());
    }

  }*/
  public connectionPositionPairs: ConnectionPositionPair[] = [
    new ConnectionPositionPair(
      { originX: 'end', originY: 'top' },
      { overlayX: 'start', overlayY: 'top' },
      0,
      0
    ),
  ];
  private destroy$ = new Subject<boolean>();
  protected choosenServices = ['All services', 'Pinned services', 'Not allocated services'];
  protected selectSection = 'Select section';

  protected readonly ICONS_MAP = ICONS_MAP;

  constructor(
    private router: Router,
    protected menuService: MenuService,
    private authService: AuthService,
    private localStorageApi: LocalStorageService,
    private translateService: TranslateService,
    private eRef: ElementRef,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private favoritesApiService: FavoritesApiService,
    private messageService: InsparkMessageService,
    private applicationsApi: ApplicationsApiService,
    private configureService: ConfigureService,
    public mainTempService: MainTempService
  ) {
    this.menuType = FavoriteType.MENU;
    this.applicationsApi.getAllWithCache().subscribe((data) => (this.applications = data));
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  ngOnInit() {
    this.menuService.menu.subscribe((items) => {
      this.menuArray = [];
      this.appMenuArray = [
        {
          id: 1000,
          iconCss: 'in in-store',
          title: gettext('MENU_STORE.MAIN'),
          apiList: [ApiList.ExWidget],
          children: [
            {
              id: 1001,
              pathArray: ['store'],
              apiList: [ApiList.ExWidget],
              // visibility: `sysuser`,
              minPrivilegy: 'update',
              title: gettext('MENU_STORE.LIST'),
              iconCss: 'in in-widgets-outline',
            },
            {
              id: 1002,
              pathArray: ['store', 'my'],
              apiList: [ApiList.ExWidget],
              minPrivilegy: 'update',
              // visibility: `sysuser`,
              title: gettext('MENU_STORE.MY'),
              iconCss: 'in in-widgets',
            },
          ],
        },
      ];
      items.slice().forEach((menuItem) => {
        if (menuItem.apiLists) {
          for (let i = 0; i < menuItem.apiLists.length; i++) {
            if (
              menuItem.apiLists[i].every((api) =>
                this.menuService.checkAccess(
                  ApiList[api].toLowerCase(),
                  menuItem.minPrivilegy || 'read'
                )
              )
            ) {
              this.menuArray.push(menuItem);
              break;
            }
          }
        } else if (menuItem.apiList) {
          if (
            menuItem.apiList.every((api) =>
              this.menuService.checkAccess(
                ApiList[api].toLowerCase(),
                menuItem.minPrivilegy || 'read'
              )
            )
          ) {
            this.menuArray.push(menuItem);
          }
        } else if (menuItem.children) {
          const tempMenuItem = Object.assign({}, menuItem, {
            children: menuItem.children.filter((_menuItem) => {
              if (_menuItem.apiLists) {
                for (let i = 0; i < _menuItem.apiLists.length; i++) {
                  if (
                    _menuItem.apiLists[i].every((api) =>
                      this.menuService.checkAccess(
                        ApiList[api].toLowerCase(),
                        _menuItem.minPrivilegy || 'read'
                      )
                    )
                  ) {
                    return true;
                  }
                }
              } else if (_menuItem.apiList) {
                return _menuItem.apiList.every((api) =>
                  this.menuService.checkAccess(
                    ApiList[api].toLowerCase(),
                    _menuItem.minPrivilegy || 'read'
                  )
                );
              } else {
                return true;
              }
            }),
          });
          if (tempMenuItem.children.length > 0) {
            this.menuArray.push(tempMenuItem);
          }
        } else {
          this.menuArray.push(menuItem);
        }
      });
      const favoriteMenu = this.menuService.favoriteMenu;
      if (favoriteMenu) {
        const visibleItems = JSON.parse(favoriteMenu);
        if (this.menuArray?.length > 0) {
          this.menuArray.forEach((menuItem) => {
            if (menuItem.id) {
              menuItem.visible = (visibleItems.description as number[]).includes(menuItem.id);
            }
            if (menuItem.children) {
              menuItem.children.forEach((child) => {
                child.visible = (visibleItems.description as number[]).includes(child.id);
              });
            }
          });
        }
      } else {
        this.favoritesApiService.getAll(this.menuType).subscribe((menuData) => {
          if (menuData && menuData.length > 0) {
            this.menuService.favoriteMenu = JSON.stringify(menuData[0]);
            const visibleMenu = JSON.parse(menuData[0].description) as number[];
            if (this.menuArray?.length > 0) {
              this.menuArray.forEach((menuItem) => {
                if (menuItem.id) {
                  menuItem.visible = visibleMenu.includes(menuItem.id);
                }
                if (menuItem.children) {
                  menuItem.children.forEach((child) => {
                    child.visible = visibleMenu.includes(child.id);
                  });
                }
              });
            }
          }
        });
      }
      this.favoriteMenuArray = _.cloneDeep(this.menuArray);
      this.cdr.detectChanges();
    });

    this.isMenuCollapsed.pipe(takeUntil(this.destroy$)).subscribe((isCollapsed) => {
      this.filterMenu();
      this.menuArray.forEach((menu) => {
        if (menu.children) {
          menu.state = false;
        }
      });
    });
  }

  makeLink(givenLink?: string[]): string {
    let link = '';
    if (givenLink?.length > 0) {
      givenLink.forEach((l) => {
        link += l + '/';
      });
    }
    return link;
  }

  addNewUser() {
    this.router.navigate(['/main', 'page', 'object']);
  }

  ngAfterViewInit() {
    this.checkSize();
  }

  public collapseMenu() {
    if (!this.isDesktop) {
      this.menuService.isCollapsed.next(true);
    }
  }

  public isActiveLink(location) {
    return this.menuService.isActiveLink(location);
  }

  public isActiveChild(menu: MenuItemLocal) {
    return menu.children.some((_menu) => {
      if (this.menuService.isActiveLink(_menu.pathArray?.join('/'))) {
        return true;
      }
    });
  }

  public isActiveChild2(menu: MenuItemLocal) {
    return this.menuService.isActiveLink(menu.pathArray?.join('/'));
  }

  checkSize() {
    const isDesktop = window.innerWidth >= DESKTOP_WIDTH;

    if (this.isDesktop !== isDesktop) {
      this.isDesktop = isDesktop;
      this.cdr.detectChanges();
    }
  }

  // checkHotKey(link): string {
  //   if (link) {
  //     if (link === '/main/page/object/') {
  //       return 'Shift O';
  //     } else if (link === '/main/page/controllersmanagement/') {
  //       return 'Shift L';
  //     } else if (link === '/main/eventslog/') {
  //       return 'Ctrl E';
  //     } else if (link === '/main/page/charts/') {
  //       return 'Shift G';
  //     } else if (link === '/main/map/') {
  //       return 'Ctrl M';
  //     } else if (link === '/main/page/reports/') {
  //       return 'Ctrl R';
  //     } else if (link === '/main/page/analitics/dashboards/') {
  //       return 'Shift A';
  //     } else if (link === '/main/page/businessparams/') {
  //       return 'Ctrl B';
  //     } else if (link === '/main/page/businessevents/') {
  //       return 'Shift J';
  //     } else if (link === '/main/page/typicalconfig/') {
  //       return 'Shift T';
  //     } else if (link === '/main/page/controlprocedure/') {
  //       return 'Shift P';
  //     } else if (link === '/main/page/paramstates/') {
  //       return 'Shift H';
  //     } else if (link === '/main/page/event/') {
  //       return 'Ctrl V';
  //     } else if (link === '/main/page/scheduletemplate/') {
  //       return 'Ctrl S';
  //     } else if (link === '/main/page/zone/') {
  //       return 'Ctrl Z';
  //     } else if (link === '/main/geo/geozones/') {
  //       return 'Ctrl X';
  //     } else if (link === '/main/page/device/') {
  //       return 'Ctlr Y';
  //     } else if (link === '/main/dashboard/') {
  //       return 'Shift W';
  //     }
  //   }
  //   return;
  // }

  selectMenu(event, menu: any) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (menu.children?.length > 0) {
      menu.visible = !menu.visible;
      const flag = menu.visible;
      menu.children.forEach((m) => (m.visible = flag));
    } else {
      menu.visible = !menu.visible;
    }
    this.savefavoriteMenuInLocalStorage();
    this.saveOnServer();
  }

  scrollTo(elementId: string): void {
    (document.getElementById(elementId) as HTMLElement).scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }

  clickedOutsideOverlay(e) {
    if (
      !this.menuService.isCollapsed.getValue() &&
      !(e.target.closest('.c-btn_menu-toggle') || e.target.closest('.main-menu__item-li'))
    ) {
      this.menuService.isCollapsed.next(true);
      this.menufilter = '';
    }
  }

  // execMenu(event, menu: any) {
  //   event.stopPropagation();
  //   if (menu.queryParams$) {
  //     menu.queryParams$.subscribe(params => {
  //       // console.log('execMenu: ' + menu.title + ', params:  ' +  JSON.stringify(params));
  //       this.router.navigate(menu.pathArray, params);
  //     })
  //   } else {
  //     this.router.navigate(menu.pathArray);
  //   }
  //   // [queryParams]='child.queryParams$ ? (child.queryParams$ | async) : child.queryParams'
  //   //   [routerLink]='child.path$ ? (child.path$| async) : child.pathArray'
  //   this.menuService.isCollapsed.next(true);
  // }

  closeMenu() {
    this.menuService.isCollapsed.next(true);
    this.menufilter = '';
  }

  savefavoriteMenuInLocalStorage() {
    //const visiblemenu = JSON.stringify(this.menuArray.filter(menu => menu.visible === true));
    const menu = _.cloneDeep(this.menuArray);
    const visibleItems: number[] = [];

    let favMenu: any = {};
    let allFavIds: number[] = [];

    try {
      if (this.menuService.favoriteMenu) {
        favMenu = JSON.parse(this.menuService.favoriteMenu);
        allFavIds = JSON.parse(favMenu.description || '[]');
      }
    } catch (e) {
      console.warn('Ошибка разбора favoriteMenu:', e);
      allFavIds = [];
    }

    menu.forEach((menu) => {
      if (menu.children) {
        menu.children.forEach((child) => {
          if (child.visible) {
            visibleItems.push(child.id);
          } else if (allFavIds.includes(child.id)) {
            allFavIds = allFavIds.filter((_id) => _id !== child.id);
          }
        });
        if (this.isVisibleChildren(menu.children) > 0) {
          visibleItems.push(menu.id);
        } else {
          allFavIds = allFavIds.filter((_id) => _id !== menu.id);
        }
      } else {
        if (menu.visible) {
          visibleItems.push(menu.id);
        }
      }
    });

    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }

    const params: Omit<FavoriteModel, 'id'> = {
      url: '',
      description: JSON.stringify([...allFavIds, ...visibleItems].filter(onlyUnique)),
      linkobjid: undefined,
      linktype: FavoriteType.MENU,
    };
    const favoriteMenu = JSON.stringify(params);
    this.menuService.favoriteMenu = favoriteMenu;
  }

  saveOnServer() {
    const favoriteMenu = JSON.parse(this.menuService.favoriteMenu);
    if (favoriteMenu && favoriteMenu.id) {
      const params: Omit<FavoriteModel, 'id'> = {
        url: '',
        description: favoriteMenu,
        linkobjid: undefined,
        linktype: FavoriteType.MENU,
      };
      this.favoritesApiService.save(favoriteMenu.id, params);
    } else {
      this.favoritesApiService.getAll().subscribe((favorites) => {
        let list = [];
        if (favorites) {
          list = (favorites as FavoriteModel[]).filter((fav) => fav.linktype === FavoriteType.MENU);
        }
        if (list.length === 0) {
          const params: Omit<FavoriteModel, 'id'> = {
            url: '',
            description: favoriteMenu.description,
            linkobjid: undefined,
            linktype: FavoriteType.MENU,
          };
          this.favoritesApiService.create(params).subscribe(() => {});
        } else {
          const linkId = list[0].id;
          const params: Omit<FavoriteModel, 'id'> = {
            url: '',
            description: favoriteMenu.description,
            linkobjid: undefined,
            linktype: FavoriteType.MENU,
          };
          this.favoritesApiService.save(linkId, params).subscribe((data) => {
            // this.messageService.success('Item successfully saved');
          });
        }
      });
    }
  }

  isVisibleChildren(children?: MenuItemLocal[]) {
    if (children) {
      const found = children.filter((child) => child.visible);
      return found.length;
    }
    return 0;
  }

  getVisibleChildren(children?: MenuItemLocal[]) {
    return children.filter((child) => child.visible)[0];
  }

  clearfavoriteMenu() {
    this.localStorageApi.remove(true, 'favoriteMenu');
    this.menuService.favoriteMenu = '';
    this.cdr.detectChanges();
  }

  gotoMainApp() {
    window.document.location.href = '/#!/main';
  }

  protected filterMenu() {
    let mmm = [];
    this.menuArray.forEach((menu) => {
      let found = [];
      if (menu.children) {
        found = menu.children.filter((child) => {
          const trns = this.translateService.instant(child.title);
          if (
            trns.toLowerCase().includes(this.menufilter.toLowerCase()) ||
            child.title.toLowerCase().includes(this.menufilter.toLowerCase())
          ) {
            delete child.filtered;
          } else {
            child.filtered = true;
          }
        });
      }
    });
  }

  protected clear() {
    this.menufilter = '';
    this.filterMenu();
  }

  protected chooseService() {
    this.selIndex = (this.selIndex + 1) % 3;
  }

  protected filter(children) {
    if (!children) {
      return [];
    }
    return children.filter((child) => this.filterFastenHeader(child));
  }

  private filterFastenHeader(header) {
    if (header.filtered) {
      return false;
    }
    if (this.selIndex === 0) {
      return true;
    }
    if (header.children) {
      for (let i = 0; i < header.children.length; i++) {
        if (this.selIndex === 1) {
          if (header.children[i].visible) {
            return true;
          }
        } else if (this.selIndex === 2) {
          if (!header.children[i].visible) {
            return true;
          }
        }
      }
    } else {
      return this.selIndex === 1 ? header.visible : !header.visible;
    }
    return false;
  }
}
